import React from 'react';

import DashboardContainer from './dashboardContainer';

const DashboardPage = () => {
  return (<DashboardContainer />);
}

export default DashboardPage

